/**
 * QE-02 — stale whole-profile PUT. Callers spread the ENTIRE cached project.profile into
 * PUT /projects/:id/profile, so a save by one persona re-sends (and can overwrite or
 * false-403 on) top-level keys another persona changed since this client last loaded.
 * The backend merges a patch key-by-key, so sending only the top-level keys that differ
 * from the last server-confirmed profile is equivalent for the caller's own edits and
 * leaves other personas' keys untouched.
 *
 * `baseline` is the raw scopingProfile from the last GET (or the keys we last saved).
 * With no baseline the payload is returned unchanged (legacy behaviour).
 */
export function omitUnchangedProfileKeys(payload, baseline) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) return payload;
  if (!baseline || typeof baseline !== "object") return payload;
  const out = {};
  for (const key of Object.keys(payload)) {
    let same = false;
    if (Object.prototype.hasOwnProperty.call(baseline, key)) {
      try {
        same = JSON.stringify(payload[key]) === JSON.stringify(baseline[key]);
      } catch {
        same = false;
      }
    }
    if (!same) out[key] = payload[key];
  }
  return out;
}
